import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.account.temp_password;

export const tempPasswordErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    }
});
export const tempPasswordLoadingSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});